<kendo-filter #filter (valueChange)="onFilterChange($event)" [value]="data.value">
    <ng-container *ngFor="let res of data.Columns">
        <kendo-filter-field *ngIf="res.CustomFilter" field="{{res.Name}}" title="{{res.DisplayName}}"
            [editor]="res.DataType" [operators]="['eq']">
            <ng-template *ngIf="res.controlType=='select'" kendoFilterValueEditorTemplate let-currentItem>
                <kendo-dropdownlist [data]="res.dropDownTemplate?.list" textField="text" valueField="code"
                    [valuePrimitive]="true" [(ngModel)]="currentItem.value"
                    (valueChange)="editorValueChange($event, currentItem, filter.value)">
                </kendo-dropdownlist>
            </ng-template>
            <ng-template *ngIf="res.controlType=='boolean'" kendoFilterValueEditorTemplate let-currentItem>
                <mat-radio-group aria-label="Select an option" [(ngModel)]="currentItem.value"
                    (change)="RadioValueChange($event, currentItem, filter.value)">
                    <mat-radio-button value="1" class="me-3">{{'True' | translate}}</mat-radio-button>
                    <mat-radio-button value="0">{{'False' | translate}}</mat-radio-button>
                </mat-radio-group>
            </ng-template>
        </kendo-filter-field>
        <kendo-filter-field *ngIf="!res.CustomFilter" field="{{res.Name}}" title="{{res.DisplayName}}"
            [editor]="res.DataType">
            <ng-template *ngIf="res.controlType=='select'" kendoFilterValueEditorTemplate let-currentItem>
                <kendo-dropdownlist [data]="res.dropDownTemplate?.list" textField="text" valueField="code"
                    [valuePrimitive]="true" [(ngModel)]="currentItem.value"
                    (valueChange)="editorValueChange($event, currentItem, filter.value)">
                </kendo-dropdownlist>
            </ng-template>
            <ng-template *ngIf="res.controlType=='boolean'" kendoFilterValueEditorTemplate let-currentItem>
                <mat-radio-group aria-label="Select an option" [(ngModel)]="currentItem.value"
                    (change)="RadioValueChange($event, currentItem, filter.value)">
                    <mat-radio-button value="1" class="me-3">{{'True' | translate}}</mat-radio-button>
                    <mat-radio-button value="0">{{'False' | translate}}</mat-radio-button>
                </mat-radio-group>
            </ng-template>
        </kendo-filter-field>
    </ng-container>
</kendo-filter>